import isEmail from 'validator/lib/isEmail';

export const validateEmail = (value?: string | null) => {
  if (!value || !isEmail(value)) {
    return 'Please enter a valid email address';
  }

  return undefined;
};
